export default __webpack_public_path__ + "static/media/640_business04-es-mobile.96e0b441.png";